import { render, staticRenderFns } from "./Elogios.vue?vue&type=template&id=5eaeafe2&"
import script from "./Elogios.vue?vue&type=script&lang=js&"
export * from "./Elogios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports